type TestHeaderProps = {
  testTitle: string;
  level: string;
  teacherName: string;
  schoolName?: string;
  duration: string;
  totalPoints: number;
  schoolYear: string;
};

export function TestHeader({
  testTitle,
  level,
  teacherName,
  schoolName,
  duration,
  totalPoints,
  schoolYear,
}: TestHeaderProps) {
  return (
    <div className="mb-6">
      <table className="w-full border-collapse text-sm">
        <colgroup>
          <col className="w-[30%]" />
          <col className="w-[40%]" />
          <col className="w-[30%]" />
        </colgroup>
        <tbody>
          <tr>
            <td className="border border-black px-3 py-2 align-middle">
              <span className="font-bold">Full name:</span>
              <span className="ml-1 text-gray-400">................................</span>
            </td>
            <td className="border border-black px-3 py-2 align-middle text-center font-semibold">
              {testTitle}
            </td>
            <td className="border border-black px-3 py-2 align-middle">
              <span className="font-bold">Teacher :</span>
              <span className="ml-1">{teacherName}</span>
            </td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-2 align-middle">
              <span className="font-bold">Class:</span>
              <span className="ml-1 text-gray-400">................................</span>
            </td>
            <td className="border border-black px-3 py-2 align-middle text-center">
              <span className="font-bold">Level :</span>
              <span className="ml-1">{level}</span>
            </td>
            <td className="border border-black px-3 py-2 align-middle">
              <span className="font-bold">Duration :</span>
              <span className="ml-1">{duration}</span>
            </td>
          </tr>
          <tr>
            <td className="border border-black px-3 py-2 align-middle">
              <span className="font-bold">Number :</span>
              <span className="ml-1 text-gray-400">................................</span>
            </td>
            <td className="border border-black px-3 py-2 align-middle text-center">
              <span className="font-bold">School year :</span>
              <span className="ml-1">{schoolYear}</span>
            </td>
            <td className="border border-black px-3 py-2 align-middle">
              <span className="font-bold">Mark</span>
              <span className="ml-4 font-bold text-base">/ {totalPoints}</span>
            </td>
          </tr>
        </tbody>
      </table>
      {schoolName ? <p className="mt-1 text-center text-xs text-gray-500">{schoolName}</p> : null}
    </div>
  );
}
